import { useHeader } from '@contexts/header';
import { cn } from '@lib/ui/cn';
import { Star, X } from 'lucide-react';

import { Button } from './ui/button';

export function SmartBanner() {
  const { hasBanner, onSetHasBanner } = useHeader();

  const isAndroid = window.navigator.userAgent.includes('Android');
  const isIPhone = window.navigator.userAgent.includes('iPhone');

  return (
    <div
      className={cn(
        'bg-card-foreground flex items-center bg-[url(data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7)] px-2 transition-all duration-300',
        hasBanner ? 'h-[70px]' : 'h-0',
      )}>
      <button
        className="bg-foreground rounded-full p-0.5"
        onClick={() => onSetHasBanner(false)}>
        <X className="text-background size-4" />
      </button>
      <img
        alt="Logo GPMED"
        className="size-15 ml-2 rounded-xl"
        src="/apple-touch-icon.png"
      />
      <div className="text-background ml-2 flex flex-1 flex-col">
        <p className="mb-1.5 text-base font-medium leading-none">GPMED</p>
        {isAndroid && <p className="mb-1 text-xs leading-none">Google Play</p>}
        {isAndroid && (
          <div className="flex flex-row items-center gap-1">
            <p className="text-sm">5,0</p>
            <Star className="fill-background size-4" strokeWidth={1} />
          </div>
        )}
        {isIPhone && <p className="mb-1 text-sm leading-none">App Store</p>}
        {isIPhone && (
          <div className="flex flex-row items-center gap-1">
            <p className="text-sm">4,5</p>
            <Star className="fill-background size-4" strokeWidth={1} />
          </div>
        )}
      </div>

      {isAndroid && (
        <Button asChild size="sm" variant="secondary">
          <a
            href={
              'https://play.google.com/store/apps/details?id=br.com.gpmed.app'
            }
            target="_blank">
            Baixar
          </a>
        </Button>
      )}

      {isIPhone && (
        <Button asChild size="sm" variant="secondary">
          <a
            href={'https://apps.apple.com/br/app/gpmed/id6476676703'}
            target="_blank">
            Baixar
          </a>
        </Button>
      )}
    </div>
  );
}
